import { useApi } from '@/api';
import { Flex, KpiSkeleton, InfinityIcon, KpiCard } from '@blockanalitica/ui';
import { useParams } from 'react-router';
import { useTheme } from 'styled-components';

export type Wallet = {
  wallet_address: string;
  total_supply: string;
  total_supply_change: string | number;
  total_supply_change_percentage: string | number;
  total_borrow: string;
  total_borrow_change: string | number;
  total_borrow_change_percentage: string | number;
  net: string;
  liquidation_buffer: string;
  liquidation_buffer_change: string | number;
  liquidation_buffer_change_percentage: string | number;
  account_liquidity: string;
  account_liquidity_change: string | number;
  account_liquidity_change_percentage: string | number;
  health_rate: string;
  health_rate_change: string | number;
  health_rate_change_percentage: string | number;
  emode: number;
};

export default function TopKpis() {
  const theme = useTheme();
  const { walletAddress } = useParams();
  const [data, error] = useApi<Wallet>({
    url: `/wallets/${walletAddress}/`
  });

  if (error) {
    throw error;
  }

  if (!data) {
    return <KpiSkeleton />;
  }

  const defaultData: Wallet = {
    wallet_address: '0x',
    total_supply: '0',
    total_supply_change: '0',
    total_supply_change_percentage: '0',
    total_borrow: '0',
    total_borrow_change: '0',
    total_borrow_change_percentage: '0',
    net: '0',
    liquidation_buffer: '0',
    liquidation_buffer_change: '0',
    liquidation_buffer_change_percentage: '0',
    account_liquidity: '0',
    account_liquidity_change: '0',
    account_liquidity_change_percentage: '0',
    health_rate: '0',
    health_rate_change: '0',
    health_rate_change_percentage: '0',
    emode: 0
  };

  const walletData = Object.keys(data).length === 0 ? defaultData : data;

  return (
    <Flex flexDirection="column" gap="m">
      <Flex flexDirection={['column', 'row']} gap={['m', 's']}>
        <KpiCard
          title="Supplied"
          data={walletData}
          field="total_supply"
          options={{
            currency: 'USD',
            trend: true,
            notation: 'compact'
          }}
        />
        <KpiCard
          title="Borrowed"
          data={walletData}
          field="total_borrow"
          options={{
            notation: 'compact',
            currency: 'USD'
          }}
        />
        <KpiCard
          title="Health rate"
          data={walletData}
          field="health_rate"
          options={{
            valueOptions: {
              currencyValueOptions: {
                nullable: '-',
                infinityThreshold: 1000,
                infinityIcon: (
                  <InfinityIcon
                    width={theme.sizes['6']}
                    height={theme.sizes['4']}
                  />
                )
              }
            }
          }}
        />
      </Flex>
    </Flex>
  );
}
